export default "__VITE_ASSET__Bjbb8oQa__"